import { SearchTermType, SearchTermName, SearchTermsContentType, SearchTermPluralName } from './search-terms.enum';

export enum ESearchScopes {
  WORKS = 'WORK',
  RECORDINGS = 'RECORDING',
  TEMPORARILY_BLOCKED = 'BLOCKED',
}

export interface SearchTerm {
  id: string;
  type: SearchTermType;
  name: SearchTermName;
  pluralName: SearchTermPluralName;
  options?: any[];
  selected: any[];
  contentType: SearchTermsContentType;
}

export interface SearchType {
  type: SearchTermType;
  name: SearchTermName;
  pluralName: SearchTermPluralName;
  label?: string;
}

export interface ChangeFilterTypeEvent {
  filter?: SearchTerm;
  type: SearchTermType;
}

export const recordingsSearchTermTypesList: SearchType[] = [
  {
    type: SearchTermType.Term,
    name: SearchTermName.Term,
    pluralName: SearchTermPluralName.Term,
  },
  {
    type: SearchTermType.Artist,
    name: SearchTermName.Artist,
    pluralName: SearchTermPluralName.Artist,
  },
  {
    type: SearchTermType.Writer,
    name: SearchTermName.Writer,
    pluralName: SearchTermPluralName.Writer,
  },
  {
    type: SearchTermType.Title,
    name: SearchTermName.Title,
    pluralName: SearchTermPluralName.Title,
  },
  {
    type: SearchTermType.Album,
    name: SearchTermName.Album,
    pluralName: SearchTermPluralName.Album,
  },
  {
    type: SearchTermType.Lyrics,
    name: SearchTermName.Lyrics,
    pluralName: SearchTermPluralName.Lyrics,
  },
  {
    type: SearchTermType.ISRC,
    name: SearchTermName.ISRC,
    pluralName: SearchTermPluralName.ISRC,
  },
  {
    type: SearchTermType.SONG_CODE,
    name: SearchTermName.SONG_CODE,
    pluralName: SearchTermPluralName.SONG_CODE,
  },
];

export const aimsSearchTermTypesList: SearchType[] = [
  {
    type: SearchTermType.Keyword,
    name: SearchTermName.KEYWORD,
    pluralName: SearchTermPluralName.KEYWORD,
  },
  {
    type: SearchTermType.Prompt,
    name: SearchTermName.PROMPT,
    pluralName: SearchTermPluralName.PROMPT,
    label: 'Powered by AIMS',
  },
  {
    type: SearchTermType.ExternalLink,
    name: SearchTermName.EXTERNAL_LINK,
    pluralName: SearchTermPluralName.EXTERNAL_LINK,
    label: 'Powered by AIMS',
  },
];

export const worksSearchTermTypesList: SearchType[] = [
  {
    type: SearchTermType.Term,
    name: SearchTermName.Term,
    pluralName: SearchTermPluralName.WorkTerm,
  },
  {
    type: SearchTermType.Artist,
    name: SearchTermName.Artist,
    pluralName: SearchTermPluralName.Artist,
  },
  {
    type: SearchTermType.Writer,
    name: SearchTermName.Writer,
    pluralName: SearchTermPluralName.Writer,
  },
  {
    type: SearchTermType.Title,
    name: SearchTermName.Title,
    pluralName: SearchTermPluralName.Title,
  },
  {
    type: SearchTermType.Lyrics,
    name: SearchTermName.Lyrics,
    pluralName: SearchTermPluralName.Lyrics,
  },
  {
    type: SearchTermType.ISRC,
    name: SearchTermName.ISRC,
    pluralName: SearchTermPluralName.ISRC,
  },
  {
    type: SearchTermType.SONG_CODE,
    name: SearchTermName.SONG_CODE,
    pluralName: SearchTermPluralName.WorkTerm,
  },
];
